import React, { useState } from "react";
import NiaContainer from "./NiaContainer/NiaContianer";
import HeaderSimple from "./HeaderSimple/HeaderSimple";
import IAHeader from "./IAHeader";

export default function Header({
  cachedAemMenuItems,
  cachedFilteredItemMap,
  headerInfo,
  contract,
  isCES
}) {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      {isCES ? (
        <HeaderSimple
          cachedAemMenuItems={cachedAemMenuItems}
          cachedFilteredItemMap={cachedFilteredItemMap}
          headerInfo={headerInfo}
          setIsOpen={setIsOpen}
        />
      ) : (
        <IAHeader
          cachedAemMenuItems={cachedAemMenuItems}
          cachedFilteredItemMap={cachedFilteredItemMap}
          headerInfo={headerInfo}
          contract={contract}
          setIsOpen={setIsOpen}
        />
      )}
      <NiaContainer isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  )
}